import type { SiteVisit } from "@/types/realEstate";
import { SiteVisitList } from "./SiteVisitList";

export default {
  list: SiteVisitList,
  recordRepresentation: (record: SiteVisit) =>
    `Visit on ${new Date(record?.scheduled_at).toLocaleDateString()}`,
};
